import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { CurrentPlanDetails } from '../types/plan';

export const getSubscriptionData = async () => {
    try {
        const { data } = await axios.get<CurrentPlanDetails>(pathfinder('pro_tiers_get_subscription'));
        return data;
    } catch (error) {
        logger.error('Failed to fetch subscription data', error as Error);
        throw error;
    }
};
